import React from 'react';
import ButtonStyles from './styles';
import PropTypes from 'prop-types';

const DefaultButton = props => (
	<ButtonStyles {...props}>{props.content}</ButtonStyles>
);

export default DefaultButton;

DefaultButton.defaultProps = {
	textColor: '#FFFFFF'
};

DefaultButton.propTypes = {
	textColor: PropTypes.string
};
